import React from "react";

const Splash = () => {
  return (
    <div className="splash">
      <div className="inner-bg">
        <h1>Riley Iverson</h1>
        <hr/>
        <h3>Developer & Designer</h3>
        <p>As well as other things.</p>
      </div>
    </div>
  )
}

export default Splash